module.exports = __webpack_public_path__ + "static/media/OnlineJournal.83b5c5bb.jpeg";